const names = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'Mai',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  de: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember'
  ]
}

/**
 * Get month names
 * @param {'en'|'de'} language Language code
 * @returns {string[]} Month names
 */
export default function (language) {
  return names[language]
}
